import {ajax} from "@/utils/axios";
import {etdfile} from "@/assets/const";

// 上传文件
export function uploadFn (obj){
    let formData = new FormData();
    const keys = Object.keys(obj);
    keys.forEach(key=>{
      formData.append(key,obj[key]);
    })
    return ajax({
        method:'post',
        headers:{
            "Content-Type":"multipart/form-data"
        },
        url:etdfile+'upload',
        data:formData
    }).then((res)=>{
        return Promise.resolve(res)
    }).catch(err=>{
      return Promise.reject(err)
    })
}

// 下载文件
export function etdDownload (params){
  return ajax({
    url:etdfile+'download',
    responseType: "blob",
    params
  }).then((res)=>{
    return Promise.resolve(res)
  })
}

// 图片预览
export function viewImage (params){
  return ajax({
    url:etdfile+'viewImage',
    responseType: "blob",
    params
  }).then((res)=>{
    return Promise.resolve(res)
  }).catch(err=>{
    return Promise.resolve(false)
  })
}
